// cartdrawer functions start========
//$(function ($) {
function drawerClose() {
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $('.cart-overlay').hide();
}

$(document).on("click", ".header--cart .header--cart-toggle, .header--cart-toggle", function (e) {
// $('.utils__item.header-cart').click(function(e){
  e.preventDefault();
  $('.cart-drawer').addClass('open_cartdrawer');
  $('body').addClass('js-drawer-open');
  $('.cart-overlay').show();
});


$('.cart-overlay').click(function(e){
  e.preventDefault();
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $(this).hide();
});

function carthtmldata(){
  $.ajax({
    type: 'GET', 
    url: '/cart',
    dataType: 'html',
    success: function(cart_html) {
      var cartdrawer_content = $(cart_html).find('.cart-value').html();
      $('.cart-value').html(cartdrawer_content);
      var cart_count = $(cart_html).find('.cart--external--icon .cart--external--total-items').html();
      $('.cart--external--icon .cart--external--total-items').html(cart_count);
      cartSlider();
      $('.cart-drawer').addClass('open_cartdrawer');
      $('body').addClass('js-drawer-open');
      $('.cart-overlay').show();
       $('.cart__loading').removeClass('ready');
       var propress = $(cart_html).find('.main-prog-bar-cart').html();
      if(propress){
      $('#hearde-propress-bar').html(propress);
      }else{
      var progress = `<div class="styles-module--progress-container"><div class="styles-module--tier-container"><div class="styles-module--regular_container"><div class="styles-module--progress" data-testid="progress-bar-completed" style="width:calc(0% - 2px)"></div><div class="styles-module--fullBar"></div></div><div class="styles-module--discount"><span class="styles-module--discount--text">10% OFF</span></div></div><div class="styles-module--tier-container"><div class="styles-module--regular_container"><div class="styles-module--progress" data-testid="progress-bar-completed" style="width:calc(0% - 2px)"></div><div class="styles-module--fullBar"></div></div><div class="styles-module--discount"><span class="styles-module--discount--text">20% OFF</span></div></div><div class="styles-module--tier-container"><div class="styles-module--regular_container"><div class="styles-module--progress" data-testid="progress-bar-completed" style="width:calc(0% - 2px)"></div><div class="styles-module--fullBar"></div></div><div class="styles-module--discount"><span class="styles-module--discount--text">25% OFF</span></div></div></div><div class="styles-module--sidecart-subtitle">You are 1 item away from 10% OFF</div>`;
       $('#hearde-propress-bar').html(progress);
      }     
    }
  });
}
function qunatityChange(cart_item, cart_varid){
  $.ajax({
    type: 'POST', 
    url: '/cart/change.js',
    dataType: 'json', 
    data : {
      "quantity": cart_item,
      "id": cart_varid,
    },
    success: function() {
      carthtmldata();
    }
  });

}

 $(document).on('click', '.upsell_item__content_cta', function(e){
   e.preventDefault();
   $('.cart__loading').addClass('ready');
    var id = $(this).data('id');
    var data = {
      "quantity": 1,
      "id": id
    };
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data : data,
      success: function() {
        carthtmldata();
        
      }
  });
});
function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


$(document).on('click', '.product-buy-buttons--cta', function(e){
  e.preventDefault();
  var variant = getParameterByName('variant');
  if(variant){
    $('[name="id"]').val(variant);
  }
  let addToCartForm = $('.product-buy-buttons--form');
  let formData = new FormData(addToCartForm[0]);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    carthtmldata();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  }); 


// function drawerPlus(item) {
//    $('.cart__loading').addClass('ready');
//   var cart_item = parseInt($(item).prev().val());
//   var cart_varid = $(item).prev().data('variantid');
//   cart_item += 1;
//   qunatityChange(cart_item, cart_varid);

// }
// function drawerMinus(item) {
//    $('.cart__loading').addClass('ready');
//   var cart_item = parseInt($(item).next().val());
//   var cart_varid = $(item).next().data('variantid');
//   cart_item -= 1;
//   qunatityChange(cart_item, cart_varid);
// }
function drawerInputitem(item) {
   $('.cart__loading').addClass('ready');
  var cart_item = parseInt($(item).val());
  var cart_varid = $(item).data('variantid');
  qunatityChange(cart_item, cart_varid);
}
function drawerRemove(item) {
   $('.cart__loading').addClass('ready');
  var cart_item = 0;
  var cart_varid = $(item).data('variantid');
  qunatityChange(cart_item, cart_varid);
}
function cartSlider(){
 const swiper = new Swiper('.swiper', {
  // Optional parameters

  // Navigation arrows
  navigation: {
    nextEl: '.upsells_header__buttons-next',
    prevEl: '.upsells_header__buttons-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
}); 
}cartSlider();




 // var endTime = $('#timer').attr('data-time');
var endTime = $('#timer').attr('data-time');
var targetTime = new Date(endTime).getTime();

var x = setInterval(function() {
  var now = new Date().getTime();
  var distance = targetTime - now;

  var hours = Math.floor(distance / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Add leading zeros if needed
  hours = (hours < 10) ? "0" + hours : hours;
  minutes = (minutes < 10) ? "0" + minutes : minutes;
  seconds = (seconds < 10) ? "0" + seconds : seconds;

  // Display the countdown timer
  $("#timer").text(hours + "h : " + minutes + "m : " + seconds + "s");

  // If the countdown is over, display a message
  if (distance < 0) {
    clearInterval(x);
    $("#timer").text("Sale ended");
  }
}, 1000);

// Cart drawer fuctionality js ===========end//});
 



       var propress = $('.main-prog-bar-cart').html();
      if(propress){
      $('#hearde-propress-bar').html(propress);
      }else{
      var progress = `<div class="styles-module--progress-container"><div class="styles-module--tier-container"><div class="styles-module--regular_container"><div class="styles-module--progress" data-testid="progress-bar-completed" style="width:calc(0% - 2px)"></div><div class="styles-module--fullBar"></div></div><div class="styles-module--discount"><span class="styles-module--discount--text">10% OFF</span></div></div><div class="styles-module--tier-container"><div class="styles-module--regular_container"><div class="styles-module--progress" data-testid="progress-bar-completed" style="width:calc(0% - 2px)"></div><div class="styles-module--fullBar"></div></div><div class="styles-module--discount"><span class="styles-module--discount--text">20% OFF</span></div></div><div class="styles-module--tier-container"><div class="styles-module--regular_container"><div class="styles-module--progress" data-testid="progress-bar-completed" style="width:calc(0% - 2px)"></div><div class="styles-module--fullBar"></div></div><div class="styles-module--discount"><span class="styles-module--discount--text">25% OFF</span></div></div></div><div class="styles-module--sidecart-subtitle">You are 1 item away from 10% OFF</div>`;
       $('#hearde-propress-bar').html(progress);
      }     
